import { create } from "zustand";
import { UserPendingData, UserPendingDataResponse } from "../models/response/userPendingDataResponse";
import userService from "../services/user.service";

interface PendingStore {
    pendingData: UserPendingDataResponse | null;
    loading: boolean;
    error: string | null;

    fetchPendingData: () => Promise<void>;
    updateBankList: (newList: UserPendingData[]) => void;
    updateDepositList: (newList: UserPendingData[]) => void;
    updateWithdrawList: (newList: UserPendingData[]) => void;
    updateProofList: (newList: UserPendingData[]) => void;
    clearPendingData: () => void;
}

export const userPendingStore = create<PendingStore>((set, get) => ({
    pendingData: null,
    loading: false,
    error: null,

    fetchPendingData: async () => {
        try {
            set({ loading: true, error: null });

            const response = await userService.fetchUserPendingData();

            if (!response.isSuccess || !response.data) {
                throw new Error(response.message || "Failed to fetch");
            }

            set({
                pendingData: response.data,
                loading: false,
            });

        } catch (err: any) {
            set({
                error: err.message,
                loading: false,
            });
        }
    },

    updateBankList: (newList) =>
        set((state) => ({
            pendingData: state.pendingData
                ? { ...state.pendingData, bankList: newList }
                : null,
        })),

    updateDepositList: (newList: UserPendingData[]) =>
        set((state) => ({
            pendingData: state.pendingData
                ? { ...state.pendingData, depositList: newList }
                : null,
        })),

    updateWithdrawList: (newList: UserPendingData[]) =>
        set((state) => ({
            pendingData: state.pendingData
                ? { ...state.pendingData, withdrawList: newList }
                : null,
        })),

    updateProofList: (newList: UserPendingData[]) =>
        set((state) => ({
            pendingData: state.pendingData
                ? { ...state.pendingData, proofList: newList }
                : null,
        })),

    clearPendingData: () =>
        set({ pendingData: null }),
}));
